import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./ScrollUp.css";

const ScrollUp = () => {
    return (
        <div
            className="scrollUpButton"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
            <KeyboardArrowUpIcon />
        </div>
    );
}

export default ScrollUp;